package team.platforma.chatdata.database.chatdata

import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass
import team.platforma.chatdata.database.ChatDatabase
import team.platforma.chatdata.table.DraftQueries
import team.platforma.chatdata.table.MokChatQueries
import team.platforma.chatdata.table.MokMessageQueries

internal val KClass<ChatDatabase>.schema: SqlSchema<QueryResult.AsyncValue<Unit>>
  get() = ChatDatabaseImpl.Schema

internal fun KClass<ChatDatabase>.newInstance(driver: SqlDriver): ChatDatabase =
    ChatDatabaseImpl(driver)

private class ChatDatabaseImpl(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver),
    ChatDatabase {
  override val draftQueries: DraftQueries = DraftQueries(driver)

  override val mokChatQueries: MokChatQueries = MokChatQueries(driver)

  override val mokMessageQueries: MokMessageQueries = MokMessageQueries(driver)

  public object Schema : SqlSchema<QueryResult.AsyncValue<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE Draft (
          |      draftID INTEGER PRIMARY KEY AUTOINCREMENT,
          |      aiModelID INTEGER NOT NULL,
          |      userID INTEGER NOT NULL,
          |      chatID INTEGER NOT NULL,
          |      text TEXT NOT NULL
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE MokChat (
          |    id INTEGER NOT NULL PRIMARY KEY,
          |    aiModelId INTEGER NOT NULL,
          |    userId INTEGER NOT NULL,
          |    name TEXT NOT NULL
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE MokMessage (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    chatId INTEGER NOT NULL,
          |    aiModelId INTEGER NOT NULL,
          |    userId INTEGER NOT NULL,
          |    textMessage TEXT NOT NULL,
          |    status TEXT NOT NULL,
          |    senderId INTEGER NOT NULL
          |)
          """.trimMargin(), 0).await()
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
    }
  }
}
